module.exports = __webpack_public_path__ + "static/media/19.45522444.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/rhand/19.png
// module id = 936
// module chunks = 0